import React from "react"
import { Form, Button, Image } from "react-bootstrap"

const TopTouristAttractionsForm = ({
  fields,
  onInputChange,
  upload,
  showAlert,
  isUploading,
  validationErrors,
  setValidationErrors,
  section = "topTouristAttractionsSection"
}) => {
  const handleInputChange = (key, value) => {
    onInputChange(section, key, value)
    if (validationErrors[`${section}.${key}`]) {
      setValidationErrors((prev) => ({
        ...prev,
        [`${section}.${key}`]: undefined,
      }))
    }
  }

  const handleFileUpload = async (key, file) => {
    try {
      const res = await upload(file)
      if (res?.url) handleInputChange(key, res.url)
    } catch (err) {
      showAlert("File upload failed.", "danger")
    }
  }

  const handleAttractionChange = (index, field, value) => {
    const attractions = [...fields.attractions]
    attractions[index][field] = value
    handleInputChange("attractions", attractions)
  }

  const handleAddAttraction = () => {
    const attractions = [...fields.attractions]
    attractions.push({ title: "", image: "", link: "" })
    handleInputChange("attractions", attractions)
  }

  const handleRemoveAttraction = (index) => {
    const attractions = [...fields.attractions]
    attractions.splice(index, 1)
    handleInputChange("attractions", attractions)
  }

  const handleAttractionImageUpload = async (index, file) => {
    try {
      const res = await upload(file)
      if (res?.url) {
        const attractions = [...fields.attractions]
        attractions[index].image = res.url
        handleInputChange("attractions", attractions)
      }
    } catch (error) {
      showAlert("Failed to upload image.", "danger")
    }
  }

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>
          Heading {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={`Heading ${fields.isVisible ? "*" : ""}`}
          value={fields.heading || ""}
          onChange={(e) => handleInputChange("heading", e.target.value)}
          isInvalid={!!validationErrors[`${section}.heading`]}
        />
        {validationErrors[`${section}.heading`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.heading`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label>
          Description {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          placeholder={`Description ${fields.isVisible ? "*" : ""}`}
          value={fields.description || ""}
          onChange={(e) => handleInputChange("description", e.target.value)}
          isInvalid={!!validationErrors[`${section}.description`]}
        />
        {validationErrors[`${section}.description`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.description`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      {/* Background Image */}
      <div className="mb-4">
        <Form.Label>Background Image</Form.Label>
        <Form.Control
          type="file"
          accept="image/*"
          onChange={(e) =>
            e.target.files?.[0] &&
            handleFileUpload("backgroundImage", e.target.files[0])
          }
        />
        {fields.backgroundImage && (
          <div className="mt-2">
            <Image
              src={fields.backgroundImage}
              thumbnail
              style={{ maxWidth: "200px" }}
            />
          </div>
        )}
      </div>

      {/* Attractions Section */}
      <h6 className="fw-bold">Attractions</h6>
      {fields.attractions?.map((attraction, idx) => (
        <div
          key={idx}
          className="border rounded p-3 mb-3 bg-light-subtle"
        >
          <Form.Control
            className="mb-2"
            placeholder="Title"
            value={attraction.title || ""}
            onChange={(e) => handleAttractionChange(idx, "title", e.target.value)}
          />

          <Form.Control
            className="mb-2"
            placeholder="Link (e.g., /sites/example or https://example.com)"
            value={attraction.link || ""}
            onChange={(e) => handleAttractionChange(idx, "link", e.target.value)}
          />

          <Form.Label>Image</Form.Label>
          <Form.Control
            type="file"
            accept="image/*"
            onChange={(e) =>
              e.target.files?.[0] &&
              handleAttractionImageUpload(idx, e.target.files[0])
            }
          />
          {isUploading && (
            <div className="text-muted small mt-1">Uploading...</div>
          )}
          {attraction.image && (
            <div className="mt-2">
              <Image
                src={attraction.image}
                thumbnail
                style={{ maxWidth: "200px" }}
              />
            </div>
          )}
          <div className="text-end mt-2">
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => handleRemoveAttraction(idx)}
            >
              Remove
            </Button>
          </div>
        </div>
      ))}
      <Button
        variant="outline-primary"
        size="sm"
        onClick={handleAddAttraction}
      >
        + Add Attraction
      </Button>
    </>
  )
}

export default TopTouristAttractionsForm
